import { useEnumTranslation } from '@cbgms/base/enums/use-enum-translation'

interface Props {
  type: string
  value: string[] | string
}

export function TranslatedEnumerable({ value, type }: Props) {
  const { te, tes } = useEnumTranslation()

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{Array.isArray(value) ? tes(type, value) : te(type, value)}</>
}
